// 考试相关
export const EXAMINATION = {
    // 添加方式
    CREATE_TYPE: {
        CUSTOMER:"customer",
        AUTO:"auto",
    },
    CREATE_TYPE_LIST: [
        { name: "手动", value: "customer" },
        { name: "自动", value: "auto" },
    ],
    // 试题类型
    TYPE: {
        SINGLE: "single", // 单选
        MULTIPLE: "multiple", // 多选
        INPUT: "input", // 简答
        TRUE_OR_FALSE: "trueOrFalse", // 判断
        BLANK: "blank", // 填空
    },
    // 类型列表
    TYPE_LIST: [
        { name: "单选题", value: "single" },
        { name: "多选题", value: "multiple" },
        { name: "判断题", value: "trueOrFalse" },
        { name: "简答题", value: "input" },
        { name: "填空题", value: "blank" },
    ],
    // 类型名
    TYPE_NAME: {
        single: "单选题", // 单选
        multiple: "多选题", // 多选
        input: "简答题", // 简答
        trueOrFalse: "判断题", // 判断
        blank: "填空题", // 填空
    },
    // 判断题选项
    TRUE_OR_FALSE_OPTIONS: [
        { name: "正确", value: "1" },
        { name: "错误", value: "2" },
    ],
    TRUE_OR_FALSE_VALUE: {
        TRUE: "1",
        FALSE: "2",
    },
    TRUE_OR_FALSE_STR: {
        1: "√",
        2: "×",
    },
    // 填空题模式
    INPUT_MODE: {
        STRICT: "strict", // 严格
        LOOSE: "loose", // 宽松
    },
    INPUT_MODE_LIST: [
        { name: "严格模式", value: "strict" },
        { name: "宽松模式", value: "loose" },
    ],

    // 试卷状态
    PAPER_STATUS: {
        ON: "on", // 启用
        OFF: "off", // 未启用
    },
    // 试卷状态列表
    PAPER_STATUS_LIST: [
        { name: "启用", value: "on" },
        { name: "未启用", value: "off" },
    ],
    // 试卷状态名
    PAPER_STATUS_NAME: {
        on: "启用", // 启用
        off: "未启用", // 未启用
    },
    // 试卷状态
    TEST_STATUS: {
        ON: "on", // 启用
        OFF: "off", // 未启用
    },
    // 测试状态列表
    TEST_STATUS_LIST: [
        { name: "启用", value: "on" },
        { name: "禁用", value: "off" },
    ],
    // 测试状态名
    TEST_STATUS_NAME: {
        on: "启用", // 启用
        off: "未启用", // 未启用
    },
    // 做题状态
    SCORE_STATUS: {
        ANSWERING: "answering", // 作答中
        SUBMIT: "submit", // 已提交
        RATED: "rated", // 已评分
    },
    // 做题状态中文
    SCORE_STATUS_NAME: {
        answering: "作答中",
        submit: "已提交",
        rated: "已评分",
    },
};

// 字典相关
export const DICT = {
    // 所有字典可用类型
    TYPE_LIST: [
        { name: "需求", value: "demand" },
        { name: "任务", value: "task" },
        { name: "任务状态", value: "taskStatus" },
        { name: "缺陷", value: "defect" },
        { name: "标签", value: "tag" },
        { name: "语言", value: "language" },
        { name: "课程证书", value: "certificate" },
        { name: "课程难度", value: "difficulty" },
        { name: "课程软件", value: "software" },
        { name: "课程类型", value: "courseType" },
    ],
    TYPE: {
        DEMAND: "demand",
        TASK: "task",
        TASK_STATUS: "taskStatus",
        DEFECT: "defect",
        TAG: "tag",
        LANGUAGE: "language",
        CERTIFICATE: "certificate",
        DIFFICULTY: "difficulty",
        SOFTWARE: "software",
        COURSE_TYPE: "courseType",
    },
};

// 模块相关
export const MODULE = {
    LIST: [
        {
            name: "需求",
            value: "demand",
            icon: "",
            desc: "记录和查看需求，保留需求下的子任务显示，方便用户跟踪管理。",
        },
        {
            name: "任务",
            value: "task",
            icon: "",
            desc: "记录团队待办事项，跟踪团队进展。",
        },
        {
            name: "代码仓库",
            value: "repository",
            icon: "",
            desc: "可靠的仓库管理功能，提供代码扫描、快照备份等能力，为代码安全保驾护航。",
        },
        {
            name: "成员",
            value: "member",
            icon: "",
            desc: "成员管理工具，提供成员编辑与周报管理功能。",
        },
        {
            name: "缺陷",
            value: "defect",
            icon: "",
            desc: "管理产品缺陷，可关联测试用例，方便开发和测试同学跟踪。",
        },
    ],
};

// 项目相关
export const PROJECT = {
    // 项目状态
    STATUS: {
        START: "start",
        PAUSE: "pause",
        CLOSE: "close",
    },
    STATUS_NAME: {
        start: "开始",
        pause: "暂停",
        close: "关闭",
    },
    STATUS_LIST: [
        { name: "开始", value: "start" },
        { name: "暂停", value: "pause" },
        { name: "关闭", value: "close" },
    ],
    // 项目类型
    TYPE: {
        // 敏捷项目
        scrum: "scrum",
        // 标准项目
        normal: "normal",
        // 看板项目
        board: "board",
    },
    TYPE_LIST: [
        {
            name: "敏捷项目",
            value: "scrum",
            cover: "https://edu.gitee.com/imgs/program_scrum_29dff1c.png",
            info: "Scrum模板是对敏捷开发方法的最佳应用，从需求池规划开始上手，通过迭代和版本来对项目进度持续推进。有效提高班级研发和交付效率。",
            module: "代码管理、工作项管理、迭代管理、版本管理、测试管理、效能度量等",
            scene: "研发管理、敏捷研发、需求管理、测试管理、版本发布规划等",
        },
        {
            name: "标准项目",
            value: "normal",
            cover: "https://edu.gitee.com/imgs/program_standard_c20bdf9.png",
            info: "标准项目模板增加了规划模块，能够通过甘特图或者日历的方式，更加直观方便的规划您的里程碑和工作项，升级后的里程碑模块能够使目标管理更加得心应手，提升班级目标性，帮助班级提升工作效率。",
            module:
                "概览、规划、工作项、测试管理、里程碑、代码评审、代码仓库、知识库、动态、报表",
            scene:
                "研发管理、需求管理、测试管理、产品进度、部门日常管理、缺陷管理、个人管理等",
        },
        {
            name: "看板项目",
            value: "board",
            cover: "https://edu.gitee.com/imgs/program_board_bd0f571.png",
            info: "看板是一种敏捷实践工具，能够将工作流程可视化，并限制进行中的工作并达到效率最大化，Kanban 使用卡片、和专栏进行持续改进，可以帮助技术和服务班级找到更加合适的工作方式！",
            module: "规划、看板、代码管理、流水线、文档、成员、动态、报表",
            scene: "研发管理、人事管理、客户管理、流程管理、个人管理等",
        },
    ],
    TYPE_NAME: {
        scrum: "敏捷项目",
        normal: "标准项目",
        board: "看板项目",
    },
    // 颜色
    COLOR_LIST: [
        "#FFF",
        "#F14A4EFF",
        "#FE824AFF",
        "#FEC953FF",
        "#C0DB53FF",
        "#72BF74FF",
        "#1FC22FFF",
        "#5DC7BEFF",
        "#71A6E7FF",
        "#4F9CDFFF",
        "#8A3EDBFF",
        "#C143D9FF",
    ],
    // 工作项管理模式
    WORK_MODE: {
        BASE: "base",
        PRO: "pro",
    },
    WORK_MODE_LIST: [
        {
            name: "极简模式",
            value: "base",
            info: "极致简单的管理模式，能够跨属性展示工作项，适用于单团队轻量协同",
        },
        {
            name: "专业模式",
            value: "pro",
            info: "专业有序的管理模式，分属性（需求、任务、缺陷）展示工作项，适用于多团队规范协同",
        },
    ],
    // 任务优先级
    TASK_PRIORITY: {
        URGENT: "urgent",
        HIGH: "high",
        NORMAL: "normal",
        LOW: "low",
        NONE: "none",
    },
    TASK_PRIORITY_LIST: [
        { name: "紧急", value: "urgent", type: "danger" },
        { name: "高", value: "high", type: "warning" },
        { name: "中", value: "normal", type: "primary" },
        { name: "低", value: "low", type: "success" },
        { name: "无优先级", value: "none", type: "info" },
    ],
    // 任务状态的属性
    TASK_STATUS_ATTRIBUTE: {
        TODO: "todo",
        DOING: "doing",
        DONE: "done",
        REJECT: "reject",
    },
    TASK_STATUS_ATTRIBUTE_LIST: [
        {
            name: "待办",
            value: "todo",
            type: "info",
        },
        {
            name: "进行中",
            value: "doing",
            type: "info",
        },
        {
            name: "已完成",
            value: "done",
            type: "success",
        },
        {
            name: "已拒绝",
            value: "reject",
            type: "danger",
        },
    ],
    // 任务日志类型
    TASK_LOG_TYPE: {
        // 修改了值
        EDIT: "edit",
        // 修改了状态
        CHANGE: "change",
    },
};

// 知识库相关
export const KNOWLEDGE = {
    // 知识库状态类型
    AUTH: {
        // 私有
        PRIVATE: "private",
        // 公开
        PUBLIC: "public",
    },
    AUTH_LIST: [
        { name: "私有", value: "private" },
        { name: "公开", value: "public" },
    ],
    TYPE: {
        MY: "my",
        JOIN: "join",
    },
    TYPE_LIST: [
        { name: "我个人的", value: "my" },
        { name: "邀请协作的", value: "join" },
    ],
    ROLE: {
        VIEW: "view",
        EDIT: "edit",
    },
    ROLE_LIST: [
        { name: "可阅读", value: "view" },
        { name: "可编辑", value: "edit" },
    ],
};

// 仓库相关
export const REPOSITORY = {
    VISIBILITY: {
        PUBLIC: "public",
        PRIVATE: "private",
    },
    VISIBILITY_LIST: [
        { name: "公开", value: "public" },
        { name: "私有", value: "private" },
    ],
    TYPE: {
        INTERNAL: "internal",
        EXTERNAL: "external",
    },
    TYPE_LIST: [
        { name: "内部", value: "internal" },
        { name: "外部", value: "external" },
    ],
    ROLE: {
        HEAD: "head",
        DEVELOP: "develop",
        VIEW: "view",
    },
    ROLE_LIST: [
        { name: "负责人", value: "head" },
        { name: "开发者", value: "develop" },
        { name: "观察者", value: "view" },
    ],
    METHOD: {
        ALL: "ALL",
        HEAD: "HEAD",
        CREATE: "CREATE",
        JOIN: "JOIN",
        STAR: "STAR",
    },
    METHOD_LIST: [
        { name: "所有", value: "ALL" },
        { name: "我负责的", value: "HEAD" },
        { name: "我创建的", value: "CREATE" },
        { name: "我参与的", value: "JOIN" },
        { name: "星标仓库", value: "STAR" },
    ],
};

// 课程相关
export const COURSE = {
    CONTENT_TYPE: {
        CHAPTER: "chapter",
        HOUR: "hour",
    },
    CONTENT_TYPE_LIST: [
        { name: "章节", value: "chapter" },
        { name: "课时", value: "hour" },
    ],
};

// 用户
export const ACCOUNT = {
    ROLE: {
        SUPER: "super",
        ADMIN: "admin",
        TEACHER: "teacher",
        STUDENT: "student",
        PARENT: "parent",
    },
    ROLE_LIST: [
        { name: "超级管理员", value: "super" },
        { name: "管理员", value: "admin" },
        { name: "教师", value: "teacher" },
        { name: "学生", value: "student" },
        { name: "家长", value: "parent" },
    ],
    STATUS: {
        ENABLE: 1,
        DISABLE: 0,
    },
    STATUS_LIST: [
        { name: "启用", value: 1 },
        { name: "禁用", value: 0 },
    ],
};

export function getEnumName(key, list) {
    return list.find((item) => item.value === key)?.name;
}

export function getEnum(key, list) {
    return list.find((item) => item.value === key) || {};
}
